import { defineComponent as _defineComponent } from 'vue'
import { isProWebCountry, saveLastProView } from '@/helpers/pro-web-helper';
import { ModalHelper } from '@/helpers/modal-helper';
import { AccountModal, ProModal } from '@/lazy-load-components';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export default /*#__PURE__*/_defineComponent({
  __name: 'RemoveAds',
  setup(__props) {

const { webLocale } = useLanguageStore();
function openModal() {
	const location = 'RemoveAdsFreeTrial';
	if (isProWebCountry(webLocale.value)) {
		ModalHelper.openModal(ProModal, {}, {}, location, true);
		saveLastProView(location);
	} else {
		ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'account-modal' }, 'AdUnit');
	}
}

return { __sfc: true,webLocale, openModal, faTimes }
}

})